<template>
    <bottom-sheet v-model="shows" title="비대면 면접 생성하기" fullscreen persistent width="720" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary">
                <vertical-form-table v-model="form" v-bind="{ items }" class="mb-20 mb-lg-40" @input="emit">
                    <template #[ENTRANCE]>
                        <form-entrance v-model="form" @input="emit" />
                    </template>
                    <template #[SCHEDULE]>
                        <form-schedule v-model="form" @input="emit" />
                    </template>
                </vertical-form-table>
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="shows = false"><span class="grey-6--text">취소</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="save"><span>생성하기</span></v-btn>
            </div>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables/attrs";
import { initInterview } from "@/assets/variables/inits";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

import FormEntrance from "./form-entrance.vue";
import FormSchedule from "./form-schedule.vue";

const ENTRANCE = "입장 권한";
const SCHEDULE = "면접 일정";

const items = [
    {
        key: "title",
        term: "면접 명칭",
        type: "text",
    },
    {
        key: "entrance",
        term: ENTRANCE,
    },
    {
        key: "schedule",
        term: SCHEDULE,
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        BottomSheet,
        VerticalFormTable,

        FormEntrance,
        FormSchedule,
    },
    props: {
        value: { type: Object, default: initInterview },
    },
    data: () => ({
        form: initInterview(),

        shows: false,
        loading: false,

        items,
        ENTRANCE,
        SCHEDULE,
    }),
    methods: {
        init() {
            this.tab = 0;
            this.loading = false;
            this.form = initInterview(this.value);
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { ...form } = this.form;
                let { interview } = await api.v1.company.interviews.post(form);
                this.form = initInterview(interview);
                alert(`생성되었습니다.\r\n참여코드: ${interview.code}`);
                this.$emit("input", this.form);
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },

        emit() {
            this.form = initInterview(this.form);
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-right input {
        text-align: right;
    }
    .v-input--switch label {
        margin-bottom: 4px;
    }
    .v-textarea textarea {
        margin: 0 !important;
        padding-top: 8px;
        line-height: 1.875em;
    }
}
</style>
